package com.essntl.features.service.ui.addeditservice.components

import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.essntl.features.service.ui.addeditservice.AddEditServiceEvent
import com.essntl.features.service.ui.addeditservice.AddEditServiceState
import com.essntl.features.service.ui.components.unsplash.ServiceUnsplash
import com.essntl.uikit.components.utils.spacing

@Composable
internal fun UnsplashSectionItem(
    state: AddEditServiceState,
    onEvent: (AddEditServiceEvent) -> Unit,
    enabled: Boolean,
) {
    Spacer(modifier = Modifier.height(2.spacing))

    ServiceUnsplash(
        state = state,
        onEvent = onEvent,
        enabled = enabled,
    )
}